// Selectors
const clickElementSelector = '.js-etracker__click-element';
const mediumNameDataSelector = 'data-etracker-medium-name';
const trackingIdDataSelector = 'data-etracker-tracking-id';

export function initClickTracking()
{
    document.querySelectorAll(clickElementSelector).forEach(clickElement =>
    {
        // Remove old event listeners
        clickElement.addEventListener('click', pushClickToDataLayer);
        clickElement.addEventListener('auxclick', pushClickToDataLayer);

        // Add fresh event listeners
        clickElement.addEventListener('click', pushClickToDataLayer);
        clickElement.addEventListener('auxclick', pushClickToDataLayer);
    });
}

function pushClickToDataLayer(event)
{
    if (event.button !== 0 && event.button !== 1)
    {
        return;
    }

    const clickTarget = event.target.closest(clickElementSelector);
    const mediumName = clickTarget.getAttribute(mediumNameDataSelector);
    const trackingId = clickTarget.getAttribute(trackingIdDataSelector);

    if (mediumName && trackingId)
    {
        window.dataLayer.push({
            'event': 'etrackerClick',
            'etrackerClickMedium': mediumName,
            'etrackerClickId': trackingId
        });
    }
}
